import Vue from 'vue';
import { mapGetters } from 'vuex';
import { systemPromoCodes } from '@/constants/baseConstants';
import { getPassportUrl } from '@/utils/other';
export default Vue.extend({
    name: 'BonusAccrualAccordion',
    data: () => {
        return {
            panelStates: [],
            panels: [{ name: 'kyc', value: 0 }, { name: 'promo', value: 1 }, { name: 'nickname', value: 2 }]
        };
    },
    props: {
        transparent: {
            type: Boolean,
            default: false,
            required: false
        },
        deniedReasons: {
            type: Array,
            default: () => [],
            required: true
        },
        faq: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    created() {
        if (!this.faq)
            return;
        this.panels.forEach((el, idx) => {
            this.deniedReasons.includes(el.name) ? el.value = idx : el.value = -1;
        });
        this.panelStates = this.panels.map((panel) => panel.value);
    },
    computed: Object.assign(Object.assign({}, mapGetters('user', ['getUserData'])), { passportSafety() {
            return getPassportUrl('/id/', { withAcceptor: true });
        },
        tooltipPromocode() {
            const { promo } = this.getUserData;
            return systemPromoCodes.includes(promo) ? this.$t('bonusesPage.widgets.refSystemCodeExplain') : this.$t('bonusesPage.widgets.refCodeExplain', { link: promo });
        } })
});
